"use client";
import { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import SectionPlaceholder from "@/components/tabtic/SectionPlaceholder";

gsap.registerPlugin(useGSAP);

const steps = [
  "Setting up your project",
  "Installing dependencies",
  "Styling your project",
  "Getting some inspiration",
  "Building your project",
  "Deploying your project",
];

export default function Home() {
  const container = useRef<HTMLDivElement>(null);

  useGSAP(() => {
    if (!container.current) return;
    gsap.to(".steps", {
      y: -(container.current?.offsetHeight * 2.4),
      duration: 15,
      ease: "none",
    });
  });

  return (
    <div className="flex flex-col gap-2 p-5 w-screen h-screen justify-center items-center">
      <div
        ref={container}
        className="relative flex gap-5 w-96 h-32 flex-col items-center rounded-lg inset-shadow-md inset-shadow-white bg-white overflow-hidden"
      >
        <div className="absolute top-0 w-full h-1/3 bg-gradient-to-b from-white to-transparent z-10"></div>
        <div className="absolute bottom-0 w-full h-1/3 bg-gradient-to-b from-transparent to-white z-10"></div>
        <div className="steps flex flex-col gap-5 mt-[33%]">
          {steps.map((step, i) => (
            <div
              key={i}
              className="step flex flex-col items-center justify-center gap-2 w-full h-full text-center text-sm"
            >
              <div className="font-bold">{step}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
